type Context = 'search';

export type Key =
  | 'quick-search'
  | 'filtered-records'
  | 'saved'
  | 'saved-list'
  | 'saved-searches'
  | 'quick-view'
  | 'filters'
  | 'filter-options'
  | 'filter-option-autocomplete'
  | 'register'
  | 'multi-level-one'
  | 'multi-level-two'
  | 'multi-level-search';

export type Value = `${Context}-${Key}`;

export const Keys: Record<Key, Value> = {
  filters: 'search-filters',
  'filter-options': 'search-filter-options',
  'filter-option-autocomplete': 'search-filter-option-autocomplete',
  'quick-search': 'search-quick-search',
  'filtered-records': 'search-filtered-records',
  saved: 'search-saved',
  'saved-list': 'search-saved-list', // key to fetch saved searches list from api
  'saved-searches': 'search-saved-searches', // key for search results query for saved searches
  'quick-view': 'search-quick-view',
  register: 'search-register',
  'multi-level-one': 'search-multi-level-one',
  'multi-level-two': 'search-multi-level-two',
  'multi-level-search': 'search-multi-level-search',
};
